<template>
  <modal-default
    ref="modal"
    :title="'Lead Call Script - ' + callScript.name"
    is-wide
  >
    <div class="modal-inner">
      <app-loading-section
        :loading="loadingSection"
        :count="callScript.length && callScript.steps.length"
        heading="Call script doesn't have steps"
      >
        <p class="mb-150">{{ callScript.description }}</p>

        <ol
          type="1"
          class="mt-200 ml-100"
        >
          <li
            class="mb-150"
            v-for="step in callScript.steps"
            :key="step.id"
          >
            <span v-html="step.statement"></span>

            <call-script-public-step-fields
              :field-data="fieldData[step.id]"
              :step-id="step.id"
              :validation-errors="validationErrors"
              v-if="fieldData[step.id]"
            ></call-script-public-step-fields>
          </li>
        </ol>
      </app-loading-section>
    </div>

    <template v-slot:footer>
      <button-default
        :loading="loadingButton"
        @click="save"
      >
        Save
      </button-default>
    </template>
  </modal-default>
</template>

<script>
import CallScriptPublicStepFields from "../modules/settings/components/CallScriptPublicStepFields";
import {MODELS} from "../services/models";
import {ENUMS} from "../services/enums";

export default {
  name: "LeadCallScriptForm",
  components: {
    CallScriptPublicStepFields
  },
  data() {
    return {
      callScript: {},
      fieldData: {},
      form: {
        call_script_id: null,
        primary_contact_id: null,
        steps: {}
      },
      validationErrors: {},
      loadingSection: true,
      loadingButton: false,
      propertyAddressFields: [
        {
          id: 'line_1',
          inputId: 'property-streetaddress',
          label: 'Street Address',
          value: '',
          type: MODELS.Property.class_name,
          fieldType: ENUMS.CustomFieldTypeEnum.Text.value,
          placeholder: 'Property - Street Address'
        },
        {
          id: 'city',
          inputId: 'property-city',
          label: 'City',
          value: '',
          type: MODELS.Property.class_name,
          fieldType: ENUMS.CustomFieldTypeEnum.Text.value,
          placeholder: 'Property - City'
        },
        {
          id: 'state',
          inputId: 'property-state',
          label: 'State',
          value: '',
          type: MODELS.Property.class_name,
          fieldType: ENUMS.CustomFieldTypeEnum.Text.value,
          placeholder: 'Property - State'
        },
        {
          id: 'postcode',
          inputId: 'property-postcode',
          label: 'Postcode',
          value: '',
          type: MODELS.Property.class_name,
          fieldType: ENUMS.CustomFieldTypeEnum.Text.value,
          placeholder: 'Property - Postcode'
        },
      ],
      contactAddressFields: [
        {
          id: 'street',
          inputId: 'contact-streetaddress',
          label: 'Street Address',
          value: '',
          type: MODELS.Contact.class_name,
          fieldType: ENUMS.CustomFieldTypeEnum.Text.value,
          placeholder: 'Contact - Street Address'
        },
        {
          id: 'line_2',
          inputId: 'contact-line2',
          label: 'Apt, Suite, Units, etc.',
          value: '',
          type: MODELS.Contact.class_name,
          fieldType: ENUMS.CustomFieldTypeEnum.Text.value,
          placeholder: 'Contact - Apt, Suite, Units, etc.'
        },
        {
          id: 'city',
          inputId: 'contact-city',
          label: 'City',
          value: '',
          type: MODELS.Contact.class_name,
          fieldType: ENUMS.CustomFieldTypeEnum.Text.value,
          placeholder: 'Contact - City'
        },
        {
          id: 'state',
          inputId: 'contact-state',
          label: 'State',
          value: '',
          type: MODELS.Contact.class_name,
          fieldType: ENUMS.CustomFieldTypeEnum.Text.value,
          placeholder: 'Contact - State'
        },
        {
          id: 'postcode',
          inputId: 'contact-postcode',
          label: 'Postcode',
          value: '',
          type: MODELS.Contact.class_name,
          fieldType: ENUMS.CustomFieldTypeEnum.Text.value,
          placeholder: 'Contact - Postcode'
        },
      ],
    }
  },
  computed: {
    record() {
      return this.$store.state.activeRecord.record;
    },
    property() {
      return this.$store.state.activeRecord.property;
    },
    primaryContact() {
      return this.$store.state.activeRecord.contacts.find(contact => contact.id === this.record.primary_contact_id);
    },
    campaigns() {
      let data = {};
      this.$store.getters.activeCampaigns.forEach(campaign => {
        data[campaign.id] = campaign.label
      });

      return data;
    },
    contactTags() {
      let data = {}
      console.log(this.$store.getters.contactTags)
      this.$store.getters.contactTags.forEach(tag => {
        data[tag.id] = tag.label
      });
      return data
    },
  },
  methods: {
    open(callScriptId) {
      this.$refs.modal.open();

      this.$api.callScripts.get(callScriptId)
        .then(res => {
          this.callScript = res.data;
          this.loadingSection = false;

          this.initFormData();
        });
    },
    initFormData() {
      this.form.call_script_id = this.callScript.id;

      this.callScript.steps.map((step) => {
        if (step.fields.length === 0) {
          return;
        }

        this.fieldData[step.id] = step.fields.map((field) => {
          /**
           * Override Full Address to collection of address fields
           * Street Address, City, State, and Postcode
           */
          if (field.id === 'full_address') {
            let data = (field.type === MODELS.Property.class_name) ? this.propertyAddressFields : this.contactAddressFields;

            return data.map(row => {
              // match parameters if we have to pre-populate field
              row.isRequired = (field.required) ? Number(field.required) : 0;

              // force contact - line_2 into optional field
              if (row.type === MODELS.Contact.class_name && row.id === 'line_2') {
                row.isRequired = 0;
              }

              if (field.type === MODELS.Property.class_name) row.value = this.property[row.id];
              if (field.type === MODELS.Contact.class_name && this.primaryContact) row.value = this.primaryContact[row.id];

              return row;
            });
          }

          let inputId = field.displayLabel.toLowerCase().replace(/\s/gm, '');
          let data = {
            id: field.id,
            inputId: inputId,
            label: field.label,
            value: '',
            type: field.type,
            fieldType: (field.fieldType) ? field.fieldType : ENUMS.CustomFieldTypeEnum.Text.value,
            placeholder: field.displayLabel,
            isRequired: (field.required) ? Number(field.required) : 0,
            customFieldableType: null,
          }

          if (field.type === MODELS.Property.class_name) data.value = this.property[data.id];
          if (field.type === MODELS.Record.class_name) data.value = this.record[data.id];
          if (field.type === MODELS.Contact.class_name && this.primaryContact) data.value = this.primaryContact[data.id];

          if (field.type === MODELS.Record.class_name && field.id === 'campaign_id') {
            data.options = this.campaigns;
          }

          if (field.type === MODELS.Contact.class_name && field.id === 'contact_tag_id') {
            data.value = [];
            data.options = this.contactTags;
          }

          if (field.custom_field) {
            const recordField = this.record.custom_fields.find(customField => customField.id === field.custom_field.id);

            data.value = (recordField) ? recordField.value : field.custom_field.default_value;
            data.label = field.custom_field.label;
            data.options = field.custom_field.options;
            data.fieldType = field.custom_field.type;
            data.customFieldableType = field.custom_field.custom_fieldable_type;
          }

          return data;
        });

        this.fieldData[step.id] = this.fieldData[step.id].flat();
      });
    },
    save() {
      this.form.primary_contact_id = (this.primaryContact) ? this.primaryContact.id : null;
      this.form.steps = {};

      this.callScript.steps.map((step) => {
        if (this.fieldData[step.id]) {
          let mapFields = this.fieldData[step.id].map((field) => {
            return {
              id: field.id,
              value: field.value,
              type: field.type,
              custom_fieldable_type: field.customFieldableType,
              is_requrired: field.isRequired
            };
          });

          this.form.steps[step.id] = { fields: mapFields };
        }
      });

      this.loadingButton = true;
      this.$api.callScripts.patchRecord(this.record.id, this.form)
        .then(res => {
          this.$buefy.toast.open({
            message: 'Lead details was updated',
            type: 'is-success'
          });

          this.$refs.modal.close();

          return res;
        })
        .finally(() => { this.loadingButton = false; });
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
